import { environment } from '../../environments/environment';

export const DEFAULT_AI_SNAPSHOT_PROMPT =
  'Transform this 3D architectural visualization into a photorealistic luxury exterior photograph. ' +
  'Keep the exact same camera angle, framing, layout, proportions, deck, stairs, railings, furniture, ' +
  'and all design elements unchanged. Replace the flat green ground with realistic lawn, landscaping, ' +
  'and blue sky. Add natural daylight, soft ambient light, realistic shadows, detailed wood grain, ' +
  'metal cable railing, and high-end materials. Professional 35mm eye-level architectural photography, ' +
  'not CGI. Only enhance realism, do not redesign.';

// DockRail mode: waterfront wording instead of lawn/deck
export const DEFAULT_DOCK_AI_SNAPSHOT_PROMPT =
  'Transform this 3D architectural visualization into a photorealistic luxury waterfront photograph. ' +
  'Keep the exact same camera angle, framing, layout, proportions, dock, railings, furniture, ' +
  'and all design elements unchanged. Replace the flat ground with realistic calm lake water, natural ' +
  'shoreline, and blue sky. Add natural daylight, soft ambient light, realistic reflections on the water, ' +
  'detailed wood grain, metal cable railing, and high-end marine materials. Professional 35mm eye-level ' +
  'architectural photography, not CGI. Only enhance realism, do not redesign.';

export const DEFAULT_AI_SNAPSHOT_MODEL = environment.replicateModel;

export const AI_SNAPSHOT_MODEL_OPTIONS = [
  'black-forest-labs/flux-kontext-pro',
  'black-forest-labs/flux-kontext-max'
];

export const AI_SNAPSHOT_PROMPT_MAX_LENGTH = 4000;



// WEBPACK FOOTER //
// ./src/app/constants/ai-snapshot-prompt.ts